export default {
  mediaSalesByChannel: '{kpi} de Medios por Canal',
  dataView: 'Vista de Datos',
  close: 'Cerrar',
  refresh: 'Actualizar',
  saveAsImage: 'Guardar como Imagen'
}
